export class Session{
    /**Identificador del registro sesión*/
    public idSesion: number;

    constructor(
        /**Campo asociado a la credencial del usuario */
        public credencial: any,
        /**campo asociado a la ip pública donde el usuario ingresa al examen */
        public ipPublica: string,
        /**fecha de ingreso al examen */
        public fechaIngreso: Date,
        /**representa el numero de la sesion */
        public sesion: number,
        /**Representa el estado del registro */
        public estado: number
    ){

    }
}